<template>
  <v-btn
    icon
    elevation="0"
    color="primary"
    class="sidebar-toggle-btn"
    :style="toggleOffsetStyle"
    @click="toggleSidebar"
  >
    <v-icon>{{ mini_sidebar ? 'mdi-menu' : 'mdi-menu-open' }}</v-icon>
  </v-btn>
</template>

<script>
import { mapState, mapMutations } from "vuex";

/** Keep in sync with VerticalSidebar rail-width / width */
const SIDEBAR_RAIL_WIDTH = 56;
const SIDEBAR_FULL_WIDTH = 300;

export default {
  computed: {
    ...mapState(["mini_sidebar", "isMobile"]),
    /**
     * ≤1145 overlay expand: shift toggle in the app bar by (full − rail)
     * so it sits just past the overlay edge, still in the top toolbar.
     * Always set marginLeft so the 0.3s transition matches sidebar width.
     */
    toggleOffsetStyle() {
      if (!this.isMobile) return undefined;
      const offset = this.mini_sidebar
        ? 0
        : SIDEBAR_FULL_WIDTH - SIDEBAR_RAIL_WIDTH;
      return { marginLeft: `${offset}px` };
    },
  },
  methods: {
    ...mapMutations(["SET_MINI_SIDEBAR"]),
    toggleSidebar() {
      this.SET_MINI_SIDEBAR(!this.mini_sidebar);
    },
  },
};
</script>

<style scoped>
/* Match .leftSidebar width transition in styles.scss */
.sidebar-toggle-btn {
  transition: margin-left 0.3s ease-in-out;
}
</style>
